import React from "react";
import { Container, SaveButtonArea, ZoomArea, ToolBoxArea, FormArea, TitleInputArea } from "./Styled";
import { CanvasWidget } from "@projectstorm/react-canvas-core";
import NodeTypes from "../../../../model/workflowEditor/NodeTypes";
import BuilderContext from "../../../context/BuilderContext";
import { Button, Input } from 'antd';
import ToolBox from "../toolBox/ToolBox";
import FloatForm from "../floatForm/FloatForm";
import { Flow } from "../../../../model/workflowEditor/flow/types";
import OptionsMenu from "../optionsMenu/OptionsMenu";
import { flowReducer } from "../../../../business/reducers/flowReducer";

export interface SheetFlowProps {
  flow: Flow;
  onChange: (flow: Flow) => void;
}

const PERCENT_ZOOM: number = 10;

const SheetFlow: React.FunctionComponent<SheetFlowProps> = (props) => {
  const { builder } = React.useContext(BuilderContext);

  const setZoom = (percent: number) => {
    builder ?.setZoom(percent);
  }

  const onDrop = (event: any) => {
    var data = JSON.parse(
      event.dataTransfer.getData("storm-diagram-node")
    );
    var point = builder ?.getDiagramEngine().getRelativeMousePoint(event);
    builder ?.createNode(data.type as NodeTypes, point!);
    builder ?.repaint()         
  }

  const updateName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const flowUpdated = {
      ...props.flow,
      name: e.currentTarget.value
    }
    props.onChange(flowUpdated);
  }
  
  return (
    <Container
      onDrop={onDrop}
      onDragOver={event => {
        event.preventDefault();
      }}
    >
      <TitleInputArea>
        <Input onChange={(e) => updateName(e)} value={props.flow.name} />
      </TitleInputArea>
      <ZoomArea>
        <Button onClick={() => { setZoom(PERCENT_ZOOM) }}>+</Button>
        <Button onClick={() => { setZoom(-PERCENT_ZOOM) }}>-</Button>
      </ZoomArea>
      <ToolBoxArea>
        <ToolBox />
        <OptionsMenu flow={props.flow} onChange={props.onChange}></OptionsMenu>
      </ToolBoxArea>
      <FormArea>
        <FloatForm flow={props.flow}></FloatForm>
      </FormArea>
      <CanvasWidget engine={builder!.getDiagramEngine()} />
    </Container>
  );
}

export default SheetFlow;